import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from 'react-redux';
import { apiSlice } from "../data/api/api";
import searchConfigSlice from "../data/slices/search-config-slice";

const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        searchConfig: searchConfigSlice
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware().concat([
            apiSlice.middleware
        ]);
    }
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;